import React from 'react';
import useSalesforceSupportPortal from '@hooks/useSalesforceSupportPortal';
import { Box } from '@mui/material';
import { useAvContext } from '../../context/AvContextProvider';

const CopilotSendFeedback = () => {
  const { selectedApp, api } = useAvContext();
  const openSalesforcePortal = useSalesforceSupportPortal({ api, currentApp: selectedApp });

  return (
    <Box
      sx={{
        textAlign: 'center',
        alignSelf: 'center',
        textDecoration: 'underline',
        width: 'fit-content',
        fontSize: 12,
        color: theme => theme.palette.colors.neutrals[600],
        ':hover': { color: theme => theme.palette.colors.primary[500] },
        cursor: 'pointer',
      }}
      onClick={openSalesforcePortal}>
      Submit feedback
    </Box>
  );
};

export default CopilotSendFeedback;
